var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"viewBox"},[(_vm.isLoading)?_c('i',{staticClass:"el-icon-loading"}):_vm._e(),_c('div',{staticClass:"text-current"},[_vm._v(" "+_vm._s(_vm.textCurrent)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }